module.exports = __webpack_public_path__ + "img/antes_despues_172.6e01d502.png";